module.exports = __webpack_public_path__ + "img/banner1.991d99ea.jpg";